import CryptoJS from "crypto-js";
import { SECRET_KEY } from "../assets/constants/constants";

// Encryption function
export const encrypt = (data) => {
  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY
  ).toString();
  return ciphertext;
};

// Decryption function
export const decrypt = (ciphertext) => {
  if(ciphertext?.length>0){
  const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;}
};

// --- Encrypt Function (Async) ---
export const encryptFormData = async (formData) => {
  const data = {};

  for (let [key, value] of formData.entries()) {
    if (value instanceof File) {
      // return false
      // const base64 = await fileToBase64(value);
      // data[key] = {
      //   name: value.name,
      //   type: value.type,
      //   data: base64,
      // };
    } else {
      data[key] = value;
    }
  }

  const jsonString = JSON.stringify(data);
  const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
  return encrypted;
};

// --- Decrypt Function ---
export const decryptFormData = (cipherText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    const parsed = JSON.parse(decryptedString);
    const restoredFormData = new FormData();
    for (let key in parsed) {
      const value = parsed[key];
      if (value?.data && value?.type && value?.name) {
        // File-like object
        const blob = base64ToBlob(value.data, value.type);
        const file = new File([blob], value.name, { type: value.type });
        restoredFormData.append(key, file);
      } else {
        restoredFormData.append(key, value);
      }
    }

    return restoredFormData;
  } catch (err) {
    console.error("Decryption error:", err);
    return null;
  }
};

// --- Helpers ---
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]); // Get only base64 part
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};


const base64ToBlob = (base64, type) => {
  const binary = atob(base64);
  const array = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new Blob([array], { type });
};

